export default __webpack_public_path__ + "f9309545a9e8541e02f15797eb8fbb27.png";